<section class="payment-wrapper">
    <div class="container">
        <div class="pc-details d-flex justify-content-between flex-wrap">
            <div class="payment-details hideOnMobile">
                <img src="assets/images/stepper-banner.jpg" alt="image" />
            </div>
            <div class="payment-banner plan-pricedetails">
                <div class="subs-details">
                    <h2 class="servey-title show">
                        Business Signup
                    </h2>

                    <ul class="list-details">
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            2000+ health and fitness classes
                        </li>
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            Guided meditations and calming music
                        </li>
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            Pre loaded custom workouts
                        </li>
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            Nutrition tracking including barcode scanner
                        </li>
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            Community group for social wellness
                        </li>
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            Custom challenges and rewards
                        </li>
                        <li>
                            <span class="tick-red">
                                <img src="assets/images/tick-red.png" alt="">
                            </span>
                            Priority access to exclusive packages & promotions
                        </li>
                    </ul>
                </div>
                <div class="subsform">
                    <h2 class="servey-title form-title">
                        It's nice to meet you! Let's get started.
                    </h2>
                    <p style="color: red;">{{errorMsg}}</p>
                    <form id="lead-create-account" [formGroup]="b2bteamsForm">
                        <div class="form-group">
                            <input formControlName="users" class="form-control" type="text"
                                placeholder="Number of Users*" (keyup)="getPeople($event)"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57">
                            <div *ngIf="submitted && b.users.errors" class="invalid-feedback">
                                <div *ngIf="b.users.errors.required">Users is required</div>
                            </div>
                            <div *ngIf="isUsersValid" style="color: red;">Number of Users not valid</div>
                        </div>
                        <div class="form-group">
                            <input formControlName="name" class="form-control" type="text" placeholder="name*">
                            <div *ngIf="submitted && b.name.errors" class="invalid-feedback">
                                <div *ngIf="b.name.errors.required">Name is required</div>
                                <div *ngIf="b.name.errors.minlength">Name Should be at least 3 Charector</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <input formControlName="email" class="form-control" type="email"
                                placeholder="email address*">
                            <div *ngIf="submitted && b.email.errors" class="invalid-feedback">
                                <div *ngIf="b.email.errors.required">Email is required</div>
                                <div *ngIf="b.email.errors.email">Email must be a valid email address</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <input formControlName="phone" class="form-control" type="text" autocomplete
                                placeholder="phone*">
                            <div *ngIf="submitted && b.phone.errors" class="invalid-feedback">
                                <div *ngIf="b.phone.errors.required">Password is required</div>
                                <div *ngIf="b.phone.errors.minlength">Phone must be 10 digit long
                                </div>
                                <div *ngIf="b.phone.errors.maxlength">Phone must be 10 digit long
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <input formControlName="company_name" class="form-control" type="text" autocomplete
                                placeholder="company name*">
                            <div *ngIf="submitted && b.company_name.errors" class="invalid-feedback">
                                <div *ngIf="b.company_name.errors.required">Company Name is required</div>
                            </div>
                        </div>

                        <div class="form-group">
                            <input formControlName="couponCode" class="form-control" type="text" placeholder="coupon*"
                                (keyup)="corporateCouponCheck($event)">
                            <div *ngIf="submitted && b.couponCode.errors" class="invalid-feedback">
                                <div *ngIf="b.couponCode.errors.required">Coupon is required</div>
                            </div>
                        </div>

                        <div>
                            <div class="total-user">
                                <span>
                                    <h3>Number of Users</h3>
                                </span>
                                <span>
                                    <h4>{{value}}</h4>
                                </span>
                            </div>
                            <div class="total-user">
                                <span>
                                    <h3>Total</h3>
                                </span>
                                <span>
                                    <h4>{{total}}</h4>
                                </span>
                            </div>
                        </div>
                        <a class="btn login-btn strted-btn" (click)="submit()">
                            <span>
                                Proceed to Pay
                            </span>
                        </a>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>